function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import ButtonAction from './ButtonAction';
import ButtonOption from './ButtonOption';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  }
}));

const NavToolbar = ({
  className,
  toolbar = [],
  onEdit,
  onSave,
  onDelete,
  onRestore,
  onErase,
  onToggle
}) => {
  const classes = useStyles();

  if (!toolbar.length) {
    return false;
  }

  return React.createElement("nav", {
    className: className || classes.root
  }, toolbar && toolbar.map((button, index) => {
    if (button.options) {
      return React.createElement(ButtonOption, _extends({}, button, {
        key: index
      }));
    }

    return React.createElement(ButtonAction, _extends({}, button, {
      key: index
    }));
  }));
};

export default NavToolbar;